var helpers = {
	windowHeight: jQuery(window).height(),
	init: function () {
		jQuery(window).on(
			'resize',
			theme.helpers.throttle(function () {
				theme.helpers.windowHeight = jQuery(window).height();
				jQuery(window).trigger('scroll');
			}, 250)
		);
	},

	throttle: function (fn, wait) {
		var time = Date.now();
		return function () {
			if (time + wait - Date.now() < 0) {
				fn();
				time = Date.now();
			}
		};
	},

	setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	},

	getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},

	eraseCookie(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	},

	isOnScreen: function( element ){
		var win = jQuery(window);
	
		var viewport = {
			top : win.scrollTop(),
			left : win.scrollLeft()
		};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();
	
		var bounds = element.offset();
		bounds.right = bounds.left + element.outerWidth();
		bounds.bottom = bounds.top + element.outerHeight();
	
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	},

	pctApiCall: function( data, ) {
		return new Promise((resolve, reject) => {
			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				dataType: 'json',
				cache: false,
				// contentType: 'application/json', 
				// data: JSON.stringify( data ),
				data: data,
				success: function( response ){
					resolve(response);
				},
				error: function( response ){
					console.log( '^^^^^^^^^^^^^^^^^' );
					console.log( response );
				},
			}).done(function(data, textStatus, jqXHR) {
				//console.log("Success: ", data);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log( '--------' );
				console.log("Error: ", jqXHR);
				console.log("Error: ", textStatus);
				console.log("Error: ", errorThrown);
			});
		});
	},
};

export { helpers };
